let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1ZikG")).then(() => parcelRequire('Dk01j'));